import type { AgentActivityStatus } from './types'

export const VERB_TENSES: Record<string, { pre: string; post: string }> = {
  Bash: { pre: 'Bashing', post: 'Bashed' },
  Edit: { pre: 'Editing', post: 'Edited' },
  Write: { pre: 'Writing', post: 'Wrote' },
  Read: { pre: 'Reading', post: 'Read' },
  Glob: { pre: 'Globbing', post: 'Globbed' },
  Grep: { pre: 'Grepping', post: 'Grepped' },
  WebFetch: { pre: 'Fetching', post: 'Fetched' },
  WebSearch: { pre: 'Searching', post: 'Searched' },
  Task: { pre: 'Task started', post: 'Task completed' },
  MCP: { pre: 'Calling', post: 'Called' },
}

const MCP_TENSES = { pre: 'Calling', post: 'Called' } as const

export function getVerb(toolName: string, status: AgentActivityStatus): string {
  if (toolName.startsWith('MCP Server')) {
    const verb = status === 'post_tool' ? MCP_TENSES.post : MCP_TENSES.pre
    return `${verb} `
  }

  const tenses = VERB_TENSES[toolName]

  if (!tenses) {
    return `${toolName} `
  }

  const verb = status === 'post_tool' ? tenses.post : tenses.pre
  return `${verb} `
}
